export default {
    setCoordSelectMapDialogOpen({ commit }, isOpen = true) {
        commit('SET_COORD_SELECT_MAP_DIALOG_OPEN', isOpen);
    },
};
